import { createSlice } from '@reduxjs/toolkit'
import { checkAccess, getToken } from '../../admincore'
import { ADMIN_ROLES } from '../../utils/constants'
import { app_api } from '../app_api/_api'
import { auth_api } from '../auth_api/_api'

const initialState = {
  user: null,

  authorized: false, // for layouts
  loading: false, // for layouts
  business_accounts: [], // for layouts

  ca_name: null, // for top bar > profile menu
  ca_profile_picture: null, // for top bar > profile menu
  ca_roles: [], // string[] -> for top bar > profile menu & <Authorize />
  ca_permissions: [], // string[] -> <Authorize />
  ca_token: null, // for API calls / getToken()
}

const onLogout = () => {
  // Clear localStorage app.token
  localStorage.removeItem('app.token')
}

const authSlice = createSlice({
  name: '_auth',
  initialState,
  reducers: {
    logout(_, action) {
      onLogout()
      return {
        ...initialState,
        ...action.payload,
      }
    },
    authLoading(state, action) {
      state.loading = action.payload
    },
    authAuthorized(state, action) {
      state.authorized = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(auth_api.endpoints.login.matchPending, () => {
        return {
          ...initialState,
          loading: true,
        }
      })
      .addMatcher(auth_api.endpoints.login.matchRejected, (state, action) => {
        return {
          ...initialState,
          isError: true,
          error: JSON.stringify(action.payload.data),
        }
      })
      .addMatcher(auth_api.endpoints.login.matchFulfilled, (state, action) => {
        const ca = {
          ca_name: `${action.payload.user.last_name} ${action.payload.user.first_name}`,
          ca_profile_picture: action.payload.user.profile_picture,
          ca_roles: action.payload.user.roles.map(el => el.name),
          ca_permissions: [],
          ca_token: action.payload.access_token,
        }

        // Check roles needed
        if (!checkAccess(ADMIN_ROLES, ca.ca_roles)) {
          return {
            ...initialState,
            isError: true,
            error: 'Required role missing.',
          }
        }

        // Save to localStorage
        localStorage.setItem('app.token', ca.ca_token)

        return {
          ...state,
          ...ca,
          authorized: true,
          loading: false,
          user: action.payload.user,
          business_accounts: action.payload.user.business_accounts,
        }
      })
      .addMatcher(app_api.endpoints.verifyToken.matchPending, () => {
        return {
          ...initialState,
          loading: true,
        }
      })
      .addMatcher(app_api.endpoints.verifyToken.matchRejected, () => {
        onLogout()
        return {
          ...initialState,
          isError: true,
          error: 'Invalid token.',
        }
      })
      .addMatcher(app_api.endpoints.verifyToken.matchFulfilled, (state, action) => {
        const ca = {
          ca_name: `${action.payload.user.last_name} ${action.payload.user.first_name}`,
          ca_profile_picture: action.payload.user.profile_picture?.signed_url,
          ca_roles: action.payload.user.roles.map(el => el.name),
          ca_permissions: [],
          ca_token: getToken(),
        }

        // Check roles needed
        if (!checkAccess(ADMIN_ROLES, ca.ca_roles)) {
          onLogout()
          return {
            ...initialState,
            isError: true,
            error: 'Required role missing.',
          }
        }

        return {
          ...state,
          ...ca,
          authorized: true,
          loading: false,
          user: action.payload.user,
          business_accounts: action.payload.user.business_accounts,
        }
      })
  },
})

export const { logout, authLoading, authAuthorized } = authSlice.actions

export default authSlice
